//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ContentHeader from 'components/ContentHeader'
import Vue from 'vue'
import $ from 'jquery'
import DateRangePicker from 'components/DateRangePicker'
import SortOrderTableTh from 'components/SortOrderTableTh'

const Pagination = require('../plugins/vue-bootstrap-paginator').default

export default {
  components: {
    ContentHeader,
    Pagination,
    DateRangePicker,
    SortOrderTableTh
  },
  data () {
    return {
      bindingId: '',
      transactionId: '',
      searchDate: {startDate: '', endDate: '', startDateText: '', endDateText: ''},
      dateOptions: JSON.parse(JSON.stringify(this.dateRangePickerOptions)),
      coinJournalList: [],
      totalItems: 0,
      currentPage: 1,
      perPage: 0,
      appointPage: 1,
      lastPage: 0
    }
  },
  created () {
  },
  mounted () {
    this.getCoinJournal();
  },
  computed: {
  },
  methods: {
    // 获取游戏记录
    getCoinJournal: function (page = 1) {
      let $this = this
      var params = {
        page: page,
        transaction_id: this.transactionId,
        binding_id: this.bindingId,
        sdate: this.searchDate.startDateText,
        edate: this.searchDate.endDateText
      }
      Vue.http.get(this.serviceUrl('api/player/coin/journal'), {params: params}).then((response) => {
        let resp = response.data
        $this.coinJournalList = resp.coinJournal.data;
        $this.totalItems = resp.coinJournal.total;
        $this.currentPage = resp.coinJournal.current_page;
        $this.perPage = resp.coinJournal.per_page;
        $this.lastPage = resp.coinJournal.last_page;
      })
    },
    // 分页跳转
    pageChanged: function (page) {
      this.currentPage = page
      this.getCoinJournal(page);
    },
    // 跳转指定页面
    pageJumped: function () {
      var appointPage = parseInt(this.appointPage) < this.lastPage ? parseInt(this.appointPage) : this.lastPage;
      this.getCoinJournal(appointPage);
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/PageGameUserCoinJournal.vue